import "./LogoWhite.scss";
import logo from "../../assets/img/logo-white.png";
import { Link } from "react-router-dom";

export const LogoWhite = () => {
  return (
    <div className="logo">
      <Link title="Главная страница" className="logo__link" to={'/'}>
        <img
          className="logo__img "
          src={logo}
          alt="Logo"
        />
        </Link>
    </div>
  );
};
